import { render, staticRenderFns } from "./MotorQuoteSidebar.vue?vue&type=template&id=2489645a&scoped=true"
import script from "./MotorQuoteSidebar.vue?vue&type=script&lang=js"
export * from "./MotorQuoteSidebar.vue?vue&type=script&lang=js"
import style0 from "./MotorQuoteSidebar.vue?vue&type=style&index=0&id=2489645a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2489645a",
  null
  
)

export default component.exports